function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { px2rem, getSpacing, getDisplay } from '../../utils/helpers';
var InputContainer = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      isMini = _ref.isMini;
  var input = theme.input;
  var container = input.container;
  return {
    position: 'relative',
    maxWidth: px2rem(!isMini ? container.standard.maxWidth : container.mini.maxWidth)
  };
}, getSpacing, getDisplay);
export default InputContainer;